var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "adam-header-bar",
        {
          class: [
            { "bg-dev": _vm.isDevelopmentEnv },
            { "bg-uat": _vm.isUatEnv },
          ],
          attrs: { username: _vm.userName, emailaddress: _vm.userEmail },
          domProps: { showNotifications: false },
          on: { "apps-click": _vm.clickDrawer },
        },
        [
          _c(
            "span",
            {
              staticClass: "app-logo",
              attrs: { slot: "headerContent" },
              slot: "headerContent",
            },
            [
              _c("a", { attrs: { href: "/" } }, [
                _c("img", {
                  staticClass: "app-logo-img",
                  attrs: {
                    src: require("adam.ui-core/assets/brand/logo-coode-white.svg"),
                  },
                }),
              ]),
            ]
          ),
          _c(
            "span",
            { attrs: { slot: "headerContent" }, slot: "headerContent" },
            [_c("h4", [_vm._v(_vm._s(_vm.$t("appTitle")))])]
          ),
          _c(
            "div",
            { attrs: { slot: "profileDetails" }, slot: "profileDetails" },
            [_c("user-profile")],
            1
          ),
        ]
      ),
      _c(
        "app-drawer",
        {
          ref: "appDrawer",
          domProps: {
            data: _vm.applications,
            labels: _vm.getAppDrawerLabels,
            onClick: _vm.handleAppClick,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "app-drawer-logo",
              attrs: { slot: "appLogo" },
              slot: "appLogo",
            },
            [
              _c("img", {
                attrs: {
                  src: require("../../../public/logo/coode-logo-rgb.svg"),
                  alt: "COODE Logo",
                },
              }),
            ]
          ),
        ]
      ),
      _c("snackbar"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }